import React, { Component } from "react";
import { Card, CardBody, Button, Progress } from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import ViewHeader from "../view-header";
import RateModal from "../AddNewRate/RateModal";
import "../index.scss";
import AllratesPanel from "./AllratesPanel";
import PaginatedResult from "./all-rates-table";
import PageEmptyContent from "../../utils/page.empty-content";
import { commonActions, apiActions, alertActions } from "../../../_actions";
import { store } from "../../../_helpers";
import { exchangeRateService } from "../../../_services";
import { appConstants } from "../../../_constants";
import { appHelpers } from "../../../_helpers";
import PageLoading from "../../utils/page.loading";
import PageError from "../../utils/page.error";
import NotificationSystem from "react-notification-system";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class ExchangeRate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rateModalOpen: false,
      editingRate: null,
      countries: [],
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      records: [],
      status: "",
      countryCode: "",
      CurrencyCode: "",
      startDate: moment().subtract(1, "month").toDate(),
      endDate: new Date(),
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [], //Errors generated within the component form
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      //Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true,
      },
      form: {
        country: "",
        currencyCode: "",
        exchangeRateUsd: "",
        exchangeRateNgn: "",
      },
      isSaving: false,
    };
    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    const { countries } = reduxState;

    if (countries) {
      // normalize country codes to uppercase for consistent comparisons
      const normalized = (countries.Results || []).map((c) => ({
        ...c,
        Code: c.Code ? String(c.Code).toUpperCase() : c.Code,
        Name: c.Name || c.Code,
      }));
      this.setState({ countries: normalized });
    } else {
      this.fetchCountries();
    }
    this.search();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.countries !== this.props.countries && this.props.countries) {
      const normalized = (this.props.countries.Results || []).map((c) => ({
        ...c,
        Code: c.Code ? String(c.Code).toUpperCase() : c.Code,
        Name: c.Name || c.Code,
      }));
      this.setState({ countries: normalized });
    }
  }

  fetchCountries = () => {
    const { dispatch } = this.props;

    dispatch(commonActions.getAllCountries())
      .then(() => {
        const { countries } = store.getState();
        this.setState({ countries: countries ? countries.Results : [] });
        dispatch(apiActions.endRequest());
      })
      .catch(() => {
        dispatch(apiActions.endRequest());
      });
  };

  search = (pageNumber = 1) => {
    const { dispatch } = this.props;
    const { pageSize, startDate, status, endDate, CurrencyCode, countryCode } =
      this.state;

    this.setState({ contentError: false });

    dispatch(apiActions.startFullPageRequest());

    let payload = {
      PageSize: pageSize,
      From: pageNumber,
      Parameter: {
        // Country: countryCode,
        Country: countryCode ? String(countryCode).toUpperCase() : "",  // ← normalize here
        StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
        EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
        CurrencyCode: CurrencyCode ? String(CurrencyCode).toUpperCase() : "",  // ← normalize here too
        // CurrencyCode: CurrencyCode,
        Status: status,
      },
    };

    exchangeRateService
      .getAllRates(payload)
      .then((res) => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          const response = res.response || {};
          // response might contain data.Results or Results directly
          const results = (response.data && response.data.Results) || response.Results || (response.data && response.data) || [];
          const totalCount = response.TotalCount || (response.data && response.data.TotalCount) || (response.data && response.data.TotalCount) || 0;
          console.log("getAllRates response:", { resultsLength: (results && results.length), totalCount, response });

          this.setState({
            records: results || [],
            currentPage: pageNumber,
            totalCount: totalCount || 0,
          });
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(
            alertActions.error(
              appHelpers.interpretErrorResponseAlt2(res.response.Message),
            ),
          );
        }
        dispatch(apiActions.endRequest());
      })
      .catch((err) => {
        dispatch(
          alertActions.error(appHelpers.interpretErrorResponseAlt2(err)),
        );
        dispatch(apiActions.endRequest());
      });
  };

getSelectValue = (payload, valueKey) => {
  if (!payload) return '';
  const val = payload[valueKey] !== undefined && payload[valueKey] !== null
    ? payload[valueKey]
    : payload.value !== undefined && payload.value !== null
    ? payload.value
    : payload.label !== undefined && payload.label !== null
    ? payload.label
    : payload;
  return typeof val === 'object' ? '' : String(val);
};

  getCurrencyOptions = () => {
    return this.state.countries.map((country) => ({
      Code: country.Code,
      Name: country.Code,
    }));
  };

  handleCurrencyCodeChange = (value) => {
  this.setState({ CurrencyCode: typeof value === 'string' ? value : (value && value.Code) || '' });
};

handleCountryCodeChange = (payload) => {
  const value = payload && typeof payload === 'object'
    ? (payload.Name || payload.Code || '')
    : (payload || '');
  this.setState({ countryCode: value });  // ← no toUpperCase(), store raw
};
  handleStatusChange = (payload) => {
    const raw = this.getSelectValue(payload, "value");
    // store as number when option values are numeric so react-select can match types
    const numeric = /^-?\d+$/.test(String(raw)) ? Number(raw) : raw;
    this.setState({ status: numeric });
  };

  openRateModal = () => {
    this.setState({
      rateModalOpen: true,
      editingRate: null,
      form: {
        country: "",
        currencyCode: "",
        exchangeRateUsd: "",
        exchangeRateNgn: "",
      },
    });
  };
  handleFormChange = (event) => {
    const { name, value } = event.target;

    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        [name]: value,
      },
      componentErrorMessages: {
        ...prevState.componentErrorMessages,
        [name]: false,
      },
    }));
  };

  validateRateForm = () => {
    const { form } = this.state;
    let errorMessages = [];
    let formValid = true;

    if (!form.country) {
      errorMessages.country = "Please select country";
      formValid = false;
    }

    if (!form.currencyCode) {
      errorMessages.currencyCode = "Please enter currency code";
      formValid = false;
    }

    if (
      !form.exchangeRateNgn ||
      isNaN(Number(form.exchangeRateNgn)) ||
      Number(form.exchangeRateNgn) <= 0
    ) {
      errorMessages.exchangeRateNgn = "Please enter NGN exchange rate";
      formValid = false;
    }

    if (
      !form.exchangeRateUsd ||
      isNaN(Number(form.exchangeRateUsd)) ||
      Number(form.exchangeRateUsd) <= 0
    ) {
      errorMessages.exchangeRateUsd = "Please enter USD exchange rate";
      formValid = false;
    }

    this.setState({ componentErrorMessages: errorMessages });
    return formValid;
  };

  resetRateForm = () => {
    this.setState({
      rateModalOpen: false,
      editingRate: null,
      componentError: false,
      componentErrorMessages: [],
      form: {
        country: "",
        currencyCode: "",
        exchangeRateUsd: "",
        exchangeRateNgn: "",
      },
    });
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded =
      this._notificationSystem.addNotification(notification);
  };

  onRemove = (notification) => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

saveRate = () => {
  const { dispatch } = this.props;
  const { form, editingRate } = this.state;
  const activeUser = appHelpers.getActiveUser();

  if (!this.validateRateForm()) {
    return;
  }

  // local saving flag to drive modal button state
  this.setState({ isSaving: true });

  const payload = {
    Id: editingRate ? editingRate.Id : 0,
    Country: form.country,
    CurrencyCode: form.currencyCode,
    NGNExchangeRate: Number(form.exchangeRateNgn),
    USDExchangeRate: Number(form.exchangeRateUsd),
    CreatedBy: activeUser ? activeUser.userName || activeUser.UserName : "",
    ...(editingRate && {
      UpdatedBy: activeUser ? activeUser.userName || activeUser.UserName : "",
    }),
  };

  dispatch(apiActions.startRequest());

  const isEditing = Boolean(editingRate);
  const serviceCall = isEditing
    ? exchangeRateService.updateRate(payload)
    : exchangeRateService.addNewRate(payload);
  const successMessage = isEditing
    ? "Exchange rate updated successfully and awaiting admin approval"
    : "Exchange rate created successfully and awaiting admin approval";

  serviceCall
    .then((res) => {
        console.log("res from serviceCall:", res);  // 👈 add this temporarily

      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.notify(successMessage, appConstants.NOTIFY_SUCCESS);
        this.resetRateForm();
        dispatch(apiActions.endRequest());
        this.setState({ isSaving: false });
        this.search(this.state.currentPage);
        return;
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        const errorMessage = appHelpers.interpretApiError(res);  // 👈 pass res directly
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        dispatch(alertActions.error(errorMessage));
      }
      this.setState({ isSaving: false });
      dispatch(apiActions.endRequest());
    })
    .catch((err) => {
      const errorMessage = appHelpers.interpretApiError(err);  // 👈 pass err directly
      this.notify(errorMessage, appConstants.NOTIFY_ERROR);
      dispatch(alertActions.error(errorMessage));
      this.setState({ isSaving: false });
      dispatch(apiActions.endRequest());
    });
};


  // downloadType: csv = 1, pdf = 2
  downloadAll = (downloadType) => {
    const { dispatch } = this.props;
    const { pageSize, startDate, status, endDate, CurrencyCode, countryCode, currentPage } = this.state;

    // Build payload using the same normalized parameters as search()
    const payload = {
      PageSize: pageSize,
      From: currentPage || 1,
      Parameter: {
        Country: countryCode ? String(countryCode).toUpperCase() : "",
        StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
        EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
        CurrencyCode: CurrencyCode ? String(CurrencyCode).toUpperCase() : "",
        Status: status,
      },
    };

    dispatch(apiActions.startRequest());

    exchangeRateService
      .downloadAllRates(payload, downloadType)
      .then((res) => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          const response = res.response;
          const blob = response && response.data ? response.data : response;
          const ext = downloadType === 2 ? "pdf" : "csv";
          const mime = downloadType === 2 ? "application/pdf" : "text/csv";
          const stamp = new Date().toISOString().slice(0,19).replace(/[:T]/g, "-");
          const fileName = `exchange-rates-${(CurrencyCode || countryCode || 'all')}-${stamp}`;
          try {
            appHelpers.downloadFromFilestream(blob, fileName, mime);
          } catch (e) {
            const fallbackUrl = (response && response.config && response.config.url) || null;
            if (fallbackUrl) {
              appHelpers.downloadFile(fallbackUrl, fileName);
            }
          }
        } else {
          const errMsg = appHelpers.interpretErrorResponseAlt2(res.response || res);
          dispatch(alertActions.error(errMsg));
        }
        dispatch(apiActions.endRequest());
      })
      .catch((err) => {
        const errorMessage = appHelpers.interpretErrorResponseAlt2(err);
        dispatch(alertActions.error(errorMessage));
        dispatch(apiActions.endRequest());
      });
  };

  downloadExcel = () => this.downloadAll(1);
  downloadPdf = () => this.downloadAll(2);

  // Add these three methods to the ExchangeRate class:

  openEditModal = (record) => {
    // when editing, find matching country in loaded countries (case-insensitive)
    const match = this.state.countries.find(
      (c) => c.Code && record && record.Country && String(c.Code).toLowerCase() === String(record.Country).toLowerCase(),
    );
    this.setState({
      rateModalOpen: true,
      editingRate: record,
      form: {
        country: match ? match.Code : (record.Country ? String(record.Country).toUpperCase() : ""),
        currencyCode: record.CurrencyCode,
        exchangeRateUsd: String(record.USDExchangeRate),
        exchangeRateNgn: String(record.NGNExchangeRate),
      },
    });
  };

approveRate = (record) => {
  const { dispatch } = this.props;
  const activeUser = appHelpers.getActiveUser();
  const approvedBy = activeUser ? activeUser.userName || activeUser.UserName : "";

  dispatch(apiActions.startRequest());

  exchangeRateService
    .approveRate({ Id: record.Id, approvedBy })
    .then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.notify("Exchange rate approved successfully", appConstants.NOTIFY_SUCCESS);
        this.search(this.state.currentPage);
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        const errorMessage = appHelpers.interpretErrorResponseAlt2(
          res.response && res.response.Message ? res.response.Message : res.response,
        );
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        dispatch(alertActions.error(errorMessage));
      }
      dispatch(apiActions.endRequest());
    })
    .catch((err) => {
        console.log("approveRate error", err);
      const errorMessage = appHelpers.interpretErrorResponseAlt2(err);
      this.notify(errorMessage, appConstants.NOTIFY_ERROR);
      dispatch(alertActions.error(errorMessage));
      dispatch(apiActions.endRequest());
    });
};

  openHistoryDetails = (record) => {
    const histories = record && (record.histories || record.Histories || []);
    this.props.history.push({
      pathname: '/exchange-rate/history-details',
      state: {
        records: histories,
        country: record && (record.Country || record.country),
        NGNExchangeRate: record && (record.NGNExchangeRate || record.NgnExchangeRate),
        Status: record && record.Status,
      },
    });
  };
  render() {
    const {
      rateModalOpen,
      editingRate,
      form,
      countries,
      records,
      currentPage,
      pageSize,
      totalCount,
      CurrencyCode,
      countryCode,
      status,
      startDate,
      endDate,
      contentError,
    } = this.state;
    const { requesting, pageRequesting } = this.props;
    console.log(records, "records");

    return (
      <div className="view exchange-rate-view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4 exchange-rate-card">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}
            {!contentError && !pageRequesting && (
              <CardBody>
                <div>
                  <h6 className="mb-0 text-uppercase pull-left">All rates</h6>
                  <div className="pull-right">
                    <Button
                      color="secondary"
                      className="mr-2"
                      onClick={this.openRateModal}
                    >
                      Add new rate
                    </Button>
                    <Button
                      className="btn-avi-primary"
                      onClick={() =>
                        this.props.history.push("/exchange-rate/bulk-upload")
                      }
                    >
                      Bulk upload
                    </Button>
                  </div>
                  <div className="clearfix">&nbsp;</div>
                  <AllratesPanel
                    componentErrorMessages={this.state.componentErrorMessages}
                    currencyOptions={this.getCurrencyOptions()}
                    countryOptions={countries}
                    statusOptions={[
                      { label: "Pending", value: 1 },
                      { label: "Active", value: 2 },
                    ]}
                    selectedCurrencyCode={CurrencyCode}
                    selectedCountryCode={countryCode}
                    selectedStatus={status}
                    startDate={startDate}
                    endDate={endDate}
                    startDateChange={(startDate) =>
                      this.setState({ startDate })
                    }
                    endDateChange={(endDate) => this.setState({ endDate })}
                    onCurrencyCodeChange={this.handleCurrencyCodeChange}
                    onCountryCodeChange={this.handleCountryCodeChange}
                    onStatusChange={this.handleStatusChange}
                    onSearch={this.search}
                  />
                </div>
                <CardBody>
                  {!pageRequesting && records && (
                    <div>
                      <PaginatedResult
                        downloadExcel={this.downloadExcel}
                        downloadPdf={this.downloadPdf}
                        records={records}
                        currentPage={currentPage}
                        navigate={this.search}
                        pageSize={pageSize}
                        totalCount={totalCount}
                        converter={() => {}}
                        onEdit={this.openEditModal}
                        onApprove={this.approveRate}
                        onRowClick={this.openHistoryDetails}
                      />
                    </div>
                  )}
                  {!pageRequesting && !records && (
                    <PageEmptyContent message="No record match your search!" />
                  )}
                </CardBody>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>

        <RateModal
          isOpen={rateModalOpen}
          form={form}
          editingRate={editingRate}
          countries={countries}
          onChange={this.handleFormChange}
          componentErrorMessages={this.state.componentErrorMessages}
          onClose={() => this.setState({ rateModalOpen: false })}
          onSave={this.saveRate}
          isSaving={this.state.isSaving}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { requesting, pageRequesting } = state.api;
  const { countries } = state;

  return {
    requesting,
    pageRequesting,
    countries,
  };
}

export default connect(mapStateToProps)(ExchangeRate);



// WEBPACK FOOTER //
// ./src/views/exchange-rate/AllRates/index.js